/**
 * Keys that identify an open availability interaction. They are opaque strings owned by the call
 * sites, so two call sites that measure different waits can never settle each other's interaction.
 */

/** The availability Lambda's own timeout: nothing that has not answered by now ever will. */
export const AVAILABILITY_INTERACTION_TIMEOUT_MS = 30_000;

export const PICKER_INTERACTION_KEY = 'all_calendars';
export const SLOT_ADJUSTMENT_INTERACTION_KEY = 'slot_adjustment';
export const SERIES_INTERACTION_KEY = 'series';
export const CHAIN_INTERACTION_KEY = 'chain';

/** Every accordion row pages independently, so each one gets its own key. */
export const rowInteractionKey = (rowId: string): string => `row:${rowId}`;
